<div class="recorder_modal create-recorder-heatmap confirmation_modal">
  <p class="recorder_modal_title" style="text-align: center; font-size: 24px">
    <ng-container *ngIf="data?.header"> {{ data.header }}</ng-container>
    <ng-container *ngIf="!data?.header">
      {{ "phrases.schedule_your_audit_review" | translate }}
    </ng-container>
  </p>

  <div
    class="recorder_modal_text"
    style="text-align: center"
    *ngIf="data?.description"
    [innerHTML]="data?.description"
  ></div>
  <div
    class="recorder_modal_text"
    style="text-align: center"
    *ngIf="!data?.description"
  ></div>

  <mat-dialog-content class="dialog-content">
    <div #container class="meetings-iframe-container"></div>
  </mat-dialog-content>

  <div class="button_container">
    <ng-container *ngIf="!data?.noCloseButton">
      <button
        mat-raised-button
        class="primary"
        (click)="dialogRef.close(1)"
        #btnFocus="matButton"
        [autofocus]="btnFocus.focus()"
      >
        {{ "words.close" | translate }}
      </button>
    </ng-container>
  </div>
</div>
